import { useEffect, useRef } from "react";

declare global {
    interface Window {
        ymaps: any;
    }
}

export const MapPinIcon = () => (
    <svg className="w-9 h-9 text-sky-950 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z" />
    </svg>
);

export const YandexMap = () => {
    const mapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Загружаем скрипт Яндекс.Карт
        const script = document.createElement("script");
        script.src = "//api-maps.yandex.ru/2.1/?lang=ru_RU&load=package.full";
        script.type = "text/javascript";
        script.onload = () => {
            window.ymaps.ready(initMap);
        };
        document.head.appendChild(script);

        function initMap() {
            if (!mapRef.current) return;

            const map = new window.ymaps.Map(mapRef.current, {
                center: [55.810536, 37.711285],
                zoom: 14,
                controls: [],
            });

            const placemark = new window.ymaps.Placemark(
                [55.810536, 37.711285],
                {
                    balloonContentBody:
                        "<address>Россия, г. Москва, ул. 3-я Гражданская, 47</address>",
                },
                {
                    preset: "islands#redDotIcon",
                }
            );

            map.geoObjects.add(placemark);
        }

        // Очистка при размонтировании
        return () => {
            const container = mapRef.current;
            if (container) container.innerHTML = "";
        };
    }, []);

    return <div id="YMapsID" ref={mapRef} className="w-full h-[400px] rounded-2xl overflow-hidden border border-sate-200 border-solid" />;
};

export default YandexMap;

